import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getMenusRequest = () => ({
  type: 'GET_MENUS_REQUEST',
})

export const getMenusSuccess = (menusData) => ({
  type: 'GET_MENUS_SUCCESS',
  menusData,
})

export const getMenusFailure = (error) => ({
  type: 'GET_MENUS_FAILURE',
  error,
})

export const getMenus = () => {
  return (dispatch) => {
    dispatch(getMenusRequest())

    fetch(URL.BASE_URL + URL.END_POINT.menus, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((menusData) => {
        dispatch(getMenusSuccess(menusData))
      })
      .catch((error) => {
        dispatch(getMenusFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

const initialAppState = {
  menusData: null,
  loadingMenus: false,
  errorMenus: null,
}

export const menusReducer = (state = initialAppState, action) => {
  switch (action.type) {
    case 'GET_MENUS_REQUEST':
      return {
        ...state,
        loadingMenus: true,
        errorMenus: null,
      }
    case 'GET_MENUS_SUCCESS':
      return {
        ...state,
        menusData: action.menusData.menus,
        loadingMenus: false,
        errorMenus: null,
      }
    case 'GET_MENUS_FAILURE':
      return {
        ...state,
        loadingMenus: false,
        errorMenus: action.error,
      }
    default:
      return state
  }
}
